/* eslint-disable react/jsx-no-bind */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {
  useState, useMemo, useCallback, useEffect,
} from 'react';
import Layout from 'antd/lib/layout/layout';
import { useFormik, FormikProvider, Form } from 'formik';
import {
  Button, Spin, Select, Breadcrumb,
  Tooltip,
} from 'antd';
import isEqual from 'lodash.isequal';
import BreadcrumbItem from '../../lib/breadcrumbItem';
import PageTitle from '../../lib/page-title';
import useCreateGroupData from './use-сreateGroupData';
import FormControl from '../../lib/form-control';
import { useStore } from '../../../store';
import { useActions } from '../../providers/actions-provider/actions.context';
import breadcrumbSeparator from '../../../assets/icons/breadcrumbSeparator.svg';
import './create-group.less';
import capitalize from '../../../utils/capitalize';
import DeleteModal from '../../lib/delete-modal';
import { createValidator } from '../../../utils/create-validator';
import { CreateGroupDTO } from '../../../store/modules/facility/dto/create-group.dto';
import SecondaryButton from '../../lib/secondary-button';
import LeavePageModal from '../../lib/leave-page-modal';
import ImageComponent from '../../lib/map-image';
import checkPermission from '../../../utils/permissions';
import { EditGroupCombinedDTO } from '../../../store/modules/facility/dto/edit-group-combined.dto';
import CopyLine from './copy-line';
import MapScalerModal from './mapScalerModal';
import { IOrigin, IPixelsPerUnit } from './mapScalerModal.types';
import UploadAntennaModal from './uploadAntennaModal';
import PermissionsProvider from '../../providers/permissionProvider';

const { Option } = Select;

const toNumberOrNull = (raw: unknown): number | null => {
  if (raw === '' || raw === null || raw === undefined || typeof raw === 'boolean') return null;
  const parsed = Number(raw);
  return Number.isNaN(parsed) ? null : parsed;
};

const CreateGroup = (): JSX.Element => {
  const { facilityActions, tenantActions } = useActions();
  const {
    title,
    defaultGroup,
    defaultSubGroup,
    groupTypesData,
    findRootGroup,
    groupType,
    isRoot,
    isEdit,
    routes,
    id,
  } = useCreateGroupData();
  const {
    groups,
    groupTypes,
    zones,
    mapOrigin,
    mapImage,
    mapImageImage,
    tenants,
  } = useStore();
  const [tempImage, setTempImage] = useState('');
  const [imageImage, setImageImage] = useState <File>();
  const [formChanged, setFormChanged] = useState(false);
  const [mapScalerModalVisible, setMapScalerModalVisible] = useState<boolean>(false);
  const [uploadAntennaVisible, setUploadAntennaVisible] = useState<boolean>(false);

  const tenantCode = tenants?.data?.[1]?.code || groupTypesData?.[0]?.tenant;

  const loading = groups.loading
    || groupTypes.loading
    || zones.loading
    || mapOrigin.loading
    || mapImage.loading;
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const initialValues = {
    group_id: defaultGroup ? defaultGroup?.id?.toString() : '',
    groupType_id: !isRoot && groupType ? groupType?.id?.toString()
      : findRootGroup(groupTypesData)?.id.toString(),
    name: isEdit && defaultGroup ? defaultGroup.name : '',
    code: isEdit && defaultGroup ? defaultGroup.code : '',
    longitude: isEdit && mapOrigin.data && mapOrigin.data.longitude !== '' ? mapOrigin.data.longitude : '',
    latitude: isEdit && mapOrigin.data && mapOrigin.data.latitude !== '' ? mapOrigin.data.latitude : '',
    elevation: isEdit && mapOrigin.data && mapOrigin.data.elevation !== '' ? mapOrigin.data.elevation : '',
    azimuth: isEdit && mapOrigin.data && mapOrigin.data.azimuth !== '' ? mapOrigin.data.azimuth : '',
    units: isEdit && mapOrigin.data && mapOrigin.data.units ? mapOrigin.data.units : '',
    xofffset: isEdit && mapImage.data && mapImage.data.xofffset !== '' ? mapImage.data.xofffset : '',
    yoffset: isEdit && mapImage.data && mapImage.data.yoffset !== '' ? mapImage.data.yoffset : '',
    theta: isEdit && mapImage.data && mapImage.data.theta !== '' ? mapImage.data.theta : '',
    pixelsPerLength: isEdit && mapImage.data && (mapImage.data.pixelsPerLength ?? ''),
    imageimage: null,
    imagePresent: mapImageImage.data instanceof Blob,
  };

  const existingImage = mapImageImage.data instanceof Blob && mapImageImage.data;
  const hasNoWritePermission = !checkPermission('facilities', 'write');

  const formik = useFormik({
    initialValues,
    onSubmit: (values) => {
      if (isEdit) {
        facilityActions.editGroup({ name: values.name, code: values.code, id },
          {
            group_id: values.group_id,
            name: values.name,
            longitude: Number(values.longitude),
            latitude: Number(values.latitude),
            elevation: values.elevation || 0,
            azimuth: values.azimuth || 0,
            units: values.units,
          },
          {
            mapImageId: mapImage.data.id,
            mapOrigin_id: mapOrigin.data.id,
            xofffset: values.xofffset || 0,
            yoffset: values.yoffset || 0,
            theta: values.theta || 0,
            pixelsPerLength: values.pixelsPerLength || 0,
          },
          {
            imageimage: imageImage,
          });
      } else {
        facilityActions.createGroup(
          {
            name: values.name,
            code: values.code,
            group_id: values.group_id,
            groupType_id: values.groupType_id,
          },
        );
      }
    },
    validate: (values) => {
      const toValidate = {
        ...values,
        latitude: values.latitude === '' ? values.latitude : Number(values.latitude),
        longitude: values.longitude === '' ? values.longitude : Number(values.longitude),
      };

      return isEdit
        ? createValidator(EditGroupCombinedDTO, toValidate)
        : createValidator(CreateGroupDTO, toValidate);
    },
    enableReinitialize: true,
  });

  const toggleModal = () => {
    setDeleteModalVisible(!deleteModalVisible);
  };

  const onConfirmDelete = () => {
    facilityActions.deleteGroup({ id });
    toggleModal();
  };
  const mapOriginIsValid = (formValues: any) => {
    if (
      formValues.longitude
      || formValues.latitude
      || formValues.elevation
      || formValues.azimuth
      || formValues.units
    ) {
      return (
        formValues.longitude !== ''
        && formValues.latitude !== ''
        && formValues.elevation !== ''
        && formValues.azimuth !== ''
        && formValues.units
      );
    }
    return true;
  };
  const mapImageIsValid = (formValues: any) => {
    if (
      formValues.xofffset
      || formValues.yoffset
      || formValues.theta
      || formValues.pixelsPerLength
    ) {
      return (
        formValues.xofffset !== ''
        && formValues.yoffset !== ''
        && formValues.theta !== ''
        && formValues.pixelsPerLength > 0
      );
    }
    return true;
  };
  const {
    setFieldValue, values, isSubmitting, errors,
  } = formik;

  let pixelsPerLengthLabel = 'Pixels per Length';

  if (values.units === 'ft') {
    pixelsPerLengthLabel = 'Pixels per Foot';
  } else if (values.units === 'm') {
    pixelsPerLengthLabel = 'Pixels per Meter';
  }

  const formHasChanged = (!isEqual(initialValues, values)
  && mapOriginIsValid(values)
  && mapImageIsValid(values)) || formChanged;

  const { units } = mapOrigin.data;

  const unitSelectValues = [
    {
      id: 'ft',
      name: 'ft',
    },
    {
      id: 'm',
      name: 'm',
    },
  ];
  const handleFileImageChange = (target: HTMLInputElement) => {
    if (target.files && target.files[0]) {
      const file = target.files[0];
      setFormChanged(true);
      setImageImage(file);
      setTempImage(URL.createObjectURL(file));
      setFieldValue('imageimage', file.name, true);
    }
  };
  const hasMapOriginError = !!mapOrigin.error;
  const hasMapImageError = !!mapImage.error;

  const baseUrl = useMemo(() => `${window.location.protocol}//${window.location.host}`, []);

  const mapScalerEnabled = (initialValues.imagePresent || imageImage instanceof Blob)
    && values.units;

  // Reopening the scaler should show what the facility already has (AVP-862).
  const scalerInitialOrigin = useMemo<IOrigin | null>(() => {
    const xofffset = toNumberOrNull(values.xofffset);
    const yoffset = toNumberOrNull(values.yoffset);

    return xofffset === null || yoffset === null ? null : { xofffset, yoffset };
  }, [values.xofffset, values.yoffset]);

  const scalerInitialPixelsPerUnit = useMemo(
    () => toNumberOrNull(values.pixelsPerLength),
    [values.pixelsPerLength],
  );

  const onSaveHandler = useCallback(({ origin, pixelsPerUnit }
  : { origin: IOrigin; pixelsPerUnit: IPixelsPerUnit}) => {
    setFieldValue('pixelsPerLength', pixelsPerUnit);
    setFieldValue('xofffset', origin.xofffset);
    setFieldValue('yoffset', origin.yoffset);
  }, [setFieldValue]);

  useEffect(() => {
    tenantActions.getTenantsList();
  }, []);

  return (
    <PermissionsProvider pageId="facilities">
      <Layout className="main-container">
        {!!formHasChanged && !isSubmitting && <LeavePageModal />}
        <Breadcrumb
          itemRender={BreadcrumbItem}
          routes={routes}
          separator={<img src={breadcrumbSeparator} alt="breadcrumb separator" />}
          params={{
            routes,
          }}
        />
        <PageTitle back title={loading ? '' : title}>
          {
            !loading && isEdit && (
              <SecondaryButton
                disabled={hasNoWritePermission}
                onClick={toggleModal}
              >
                {`Delete ${capitalize(defaultGroup ? defaultGroup.name : '')}`}
              </SecondaryButton>
            )
          }
        </PageTitle>

        { isEdit && (
          <>
            <CopyLine text={`Edge Subscription URL:${baseUrl}/http-ingestor/ingestion/${tenantCode}/<mcon, json>/${capitalize(defaultGroup ? defaultGroup.code : '')}`} />
            <CopyLine text={`Reader Subscription URL: ${baseUrl}/http-ingestor/ingestion/${tenantCode}/<reader>/${capitalize(defaultGroup ? defaultGroup.code : '')}`} />
          </>
        ) }

        {deleteModalVisible && (
          <DeleteModal
            text={title}
            modalVisible={deleteModalVisible}
            onConfirm={onConfirmDelete}
            onCancel={toggleModal}
          />
        )}

        {
          !loading ? (
            <FormikProvider value={formik}>
              <Form className="formik-form">
                <div className="create-group-row">
                  <div className="create-group-col">
                    <div className="form__wrapper ant-col ant-form-item-label group__label" style={{ marginTop: '20px' }}>
                      <p className="group__label">Group Type</p>
                      <Select
                        disabled={hasNoWritePermission}
                        className="ant__select"
                        defaultValue={defaultSubGroup ? defaultSubGroup.id : ''}
                        // eslint-disable-next-line react/jsx-no-bind
                        onChange={(value) => {
                          setFieldValue('groupType_id', value);
                        }}
                      >
                        {Object.values(groupTypes.data).map(
                          (el) => <Option key={el.id} value={el.id}>{el.name}</Option>,
                        )}
                      </Select>
                    </div>
                    {
                      !isEdit && (
                        <div className="form__wrapper ant-col ant-form-item-label">
                          <div className="ant-col ant-form-item-label group__label">
                            <p className="group__label">Group</p>
                          </div>

                          <Select
                            disabled={hasNoWritePermission}
                            className="ant__select"
                            defaultValue={defaultGroup ? defaultGroup.id : ''}
                            // eslint-disable-next-line react/jsx-no-bind
                            onChange={(value) => {
                              setFieldValue('group_id', value);
                            }}
                          >
                            {Object.values(groups.data).map(
                              (el) => <Option key={el.id} value={el.id}>{el.name}</Option>,
                            )}
                          </Select>
                        </div>
                      )
                    }
                    <FormControl inputClassName="form__wrapper" name="name" label="Name" type="text" disabled={hasNoWritePermission} />
                    <FormControl inputClassName="form__wrapper" name="code" label="Code" type="text" disabled={hasNoWritePermission} />
                  </div>
                  {
                    isEdit && (
                      <>
                        <div className="create-group-col">
                          <FormControl
                            inputClassName="form__wrapper"
                            name="longitude"
                            label="Longitude"
                            type="text"
                            inputMode="decimal"
                            onChange={(e) => {
                              const raw = e.target.value;
                              const sanitized = raw.replace(/(?!^-)[^0-9.]|(?<=\..*)\./g, '');
                              setFieldValue('longitude', sanitized);
                            }}
                            disabled={hasNoWritePermission}
                          />
                          <FormControl
                            inputClassName="form__wrapper"
                            name="latitude"
                            label="Latitude"
                            type="text"
                            inputMode="decimal"
                            onChange={(e) => {
                              const raw = e.target.value;
                              const sanitized = raw.replace(/(?!^-)[^0-9.]|(?<=\..*)\./g, '');
                              setFieldValue('latitude', sanitized);
                            }}
                            disabled={hasNoWritePermission}
                          />
                          <FormControl inputClassName="form__wrapper" name="elevation" label="Elevation" type="number" disabled={hasNoWritePermission} />
                          <FormControl inputClassName="form__wrapper" name="azimuth" label="Azimuth (Degrees from True North)" type="number" disabled={hasNoWritePermission} />
                          <div className="form__wrapper ant-col ant-form-item-label">
                            <div className="ant-col ant-form-item-label group__label">
                              <p className="group__label">Units</p>
                            </div>
                            <Select
                              disabled={hasNoWritePermission}
                              className="ant__select"
                              defaultValue={units}
                              onChange={(value) => {
                                setFieldValue('units', value);
                              }}
                            >
                              {Object.values(unitSelectValues).map(
                                (el) => <Option key={el.id} value={el.id}>{el.name}</Option>,
                              )}
                            </Select>
                            {errors.units && (
                              <p className="form-control__error">
                                {capitalize(errors.units)}
                              </p>
                            )}
                          </div>
                        </div>
                        {
                          !hasMapOriginError && (
                            <div className="create-group-col">
                              { isEdit && (
                                <Tooltip title={mapScalerEnabled ? '' : 'Please upload facility floor plan and set units'}>
                                  <span style={{ marginTop: '44px' }}>
                                    <SecondaryButton disabled={!mapScalerEnabled || hasNoWritePermission} type="button" onClick={() => setMapScalerModalVisible(true)}>
                                      Open Map Scaler
                                    </SecondaryButton>
                                  </span>
                                </Tooltip>
                              )}
                              <FormControl inputClassName="form__wrapper" name="xofffset" label="Xoffset in pixels" type="number" disabled={hasNoWritePermission} />
                              <FormControl inputClassName="form__wrapper" name="yoffset" label="Yoffset in pixels" type="number" disabled={hasNoWritePermission} />
                              <FormControl inputClassName="form__wrapper" wrapperClassName="hidden" name="theta" label="Floor Plan Rotation (degrees)" type="number" disabled={hasNoWritePermission} />
                              <FormControl inputClassName="form__wrapper" name="pixelsPerLength" label={pixelsPerLengthLabel} type="number" disabled={hasNoWritePermission} />
                              <div className="field-separator">
                                <div className="image-upload-row">
                                  <label
                                    htmlFor="image-upload-input"
                                    style={{
                                      cursor: checkPermission('facilities', 'write') ? 'pointer' : 'not-allowed',
                                      pointerEvents: checkPermission('facilities', 'write') ? 'auto' : 'none',
                                    }}
                                  >
                                    <input
                                      type="button"
                                      value={mapImageImage.data instanceof Blob ? 'Change file' : 'Choose file'}
                                      disabled={hasNoWritePermission}
                                      style={{ pointerEvents: 'none' }}
                                    />
                                  </label>
                                  <input
                                    id="image-upload-input"
                                    name="imageimage"
                                    type="file"
                                    onChange={(event) => handleFileImageChange(event.target)}
                                    disabled={hasNoWritePermission}
                                    style={{ display: 'none' }}
                                  />
                                  <p>{values.imageimage}</p>
                                </div>
                                {
                                  !hasMapImageError && (
                                    <ImageComponent
                                      imageBlob={mapImageImage.data}
                                      altText={id}
                                      imageSrc={tempImage}
                                      thumbnailMode
                                    />
                                  )
                                }
                              </div>
                            </div>
                          )
                        }
                        <div className="create-group-col">
                          <SecondaryButton type="button" disabled={hasNoWritePermission} className="create-group-upload-btn" onClick={() => setUploadAntennaVisible(true)}>
                            Upload Antennas
                          </SecondaryButton>
                        </div>
                      </>
                    )
                  }
                </div>
                <div className="create-group-buttons">
                  <Button htmlType="submit" disabled={!formHasChanged || Object.keys(errors).length > 0} type="primary" className="formik-form__submit">
                    Save
                  </Button>
                </div>
              </Form>

            </FormikProvider>
          )
            : <Spin size="large" />
        }
        <MapScalerModal
          visible={mapScalerModalVisible}
          onCancel={() => setMapScalerModalVisible(false)}
          onSave={onSaveHandler}
          image={existingImage as Blob || imageImage}
          units={values.units}
          initialOrigin={scalerInitialOrigin}
          initialPixelsPerUnit={scalerInitialPixelsPerUnit}
        />
        <UploadAntennaModal
          visible={uploadAntennaVisible}
          onCancel={() => setUploadAntennaVisible(false)}
          facilityCode={mapOrigin?.data?.group_code as string}
        />
      </Layout>
    </PermissionsProvider>
  );
};

export default CreateGroup;
